import { useState } from "react";
import { Storage } from "aws-amplify";
import { Alert, Button, Typography } from "@mui/material";
import "./csv-picker.scss";

const CsvPicker = () => {
  const [message, setMessage] = useState("");

  const handleFileUpload = async (e) => {
    setMessage("");
    const file = e.target.files[0];
    try {
      await Storage.put(`alumni-csv/${file.name}`, file, {
        level: "private",
        contentType: file.type,
      });
      setMessage("Successfully uploaded file");
    } catch (error) {
      setMessage("Error uploading file");
    }
  };

  return (
    <div className="csv-picker">
      <Typography variant="h6" color="primary" className="title">
        Upload Alumni
      </Typography>
      {message && <Alert className="alert">{message}</Alert>}
      <label htmlFor="file-input">
        <input
          type="file"
          accept="text/csv"
          id="file-input"
          hidden
          onChange={handleFileUpload}
        />
        <Button
          fullWidth
          size="large"
          variant="contained"
          component="span"
          color="secondary"
          className="upload-button"
        >
          Pick a csv file to upload
        </Button>
      </label>
    </div>
  );
};

export default CsvPicker;
